/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-06 14:43:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Spinner, Tooltip } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Chart from 'src/components/views/analytics/display/chart';
import Total from 'src/components/views/analytics/display/total';
import { ANALYTICS } from 'src/constants/message';

type Props = WithI18nProps;
class TotalSearches extends Component<Props> {
  state = {
    errorRequest: false
  };

  componentWillReceiveProps(nextProps) {
    const { totalSearchesLoading: loading } = this.props;
    const { totalSearchesLoading: nextLoading, totalSearchesSuccess: nextSuccess } = nextProps;

    if (loading && !nextLoading && !nextSuccess) {
      this.setState({ errorRequest: true });
    }
  }

  render() {
    const {
      fromDate,
      toDate,
      compare,
      totalSearchesLoading,
      totalSearches,
      totalSearchesCompared,
      totalSearchesTotal,
      totalSearchesPercentChange,
      id,
      blockDetailId,
      i18n
    } = this.props;
    const { errorRequest } = this.state;

    const isDetail = id === blockDetailId;

    return (
      <Card
        sectioned
        title={
          <Tooltip
            content={i18n.translate('AdminHTML.Analytics.Searches.totalSearches_TooltipContent')}
            preferredPosition="above">
            <span className="Polaris-Heading">
              {i18n.translate('AdminHTML.Analytics.Searches.totalSearches_TooltipChildren')}
            </span>
          </Tooltip>
        }
        actions={[
          {
            content: isDetail
              ? i18n.translate('AdminHTML.Common.Action.hide')
              : i18n.translate('AdminHTML.Common.Action.viewDetail'),
            onAction: this.changeShowHideDetail
          }
        ]}>
        {totalSearchesLoading ? (
          <div className="spinner-loading">
            <Spinner
              accessibilityLabel={i18n.translate(
                'AdminHTML.Analytics.Common.spinner_AccessibilityLabel'
              )}
              size="large"
            />
          </div>
        ) : _.isEmpty(totalSearches) ? (
          <div className="analytic-empty">
            {errorRequest
              ? i18n.translate(ANALYTICS.ERROR_REQUEST)
              : i18n.translate('AdminHTML.Analytics.Searches.totalSearches_AnalyticEmpty')}
          </div>
        ) : (
          <React.Fragment>
            <Total
              compare={compare}
              total={totalSearchesTotal}
              percentChange={totalSearchesPercentChange}
            />
            <div style={{ marginTop: '2rem' }}>
              <Chart
                title={i18n.translate('AdminHTML.Analytics.Searches.totalSearches_ChartTitle')}
                fromDate={fromDate}
                toDate={toDate}
                compare={compare}
                source={totalSearches}
                comparedSource={totalSearchesCompared}
              />
            </div>
          </React.Fragment>
        )}
      </Card>
    );
  }

  changeShowHideDetail = () => {
    const { changeShowHideDetail, id } = this.props;
    changeShowHideDetail(id);
  };
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = (state, props) => {
  return {
    fromDate: _.get(state.analytics, 'fromDate'),
    toDate: _.get(state.analytics, 'toDate'),
    compare: _.get(state.analytics, 'compare', false),
    totalSearchesLoading: _.get(state.analytics, 'totalSearchesLoading', false),
    totalSearchesSuccess: _.get(state.analytics, 'totalSearchesSuccess', false),
    // Top total searches
    totalSearches: _.get(state.analytics, 'totalSearchesData', []),
    totalSearchesCompared: _.get(state.analytics, 'totalSearchesCompared', []),
    totalSearchesTotal: _.get(state.analytics, 'totalSearchesTotal', 0),
    totalSearchesPercentChange: _.get(state.analytics, 'totalSearchesPercentChange', 0)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(TotalSearches));
